import { useQuery } from '@apollo/client'
import GET_NONPROFIT_ORG_TEAM_QUERY from 'Apollo/Queries/GetNonprofitOrgTeam'
import { useAppState } from 'Context/AppContext/AppContext'
import { IOption, NonprofitOrgUser } from 'TypeDefs/Team'
import { useEffect, useState } from 'react'

const useNonprofitOrgTeam = () => {
  const {
    nonprofitOrgConfig: { platformPlan: planName, orgId: nonprofitOrgId },
  } = useAppState()
  const [teamMap, setTeamMap] = useState<{
    [key: string]: { firstName: string; lastName: string; email: string }
  }>()
  const [teamOptions, setTeamOptions] = useState<IOption[]>([])

  const { data: teamData } = useQuery(GET_NONPROFIT_ORG_TEAM_QUERY, {
    // fetchPolicy: 'cache-and-network',
    variables: {
      nonprofitOrgId,
      planName,
    },
  })

  useEffect(() => {
    if (teamData) {
      const {
        nonprofitOrgTeam: { users },
      } = teamData
      const teamOptionsObj: IOption[] = []
      let teamMapObj: {
        [key: string]: { firstName: string; lastName: string; email: string }
      } = {}
      users.forEach((orgUser: NonprofitOrgUser) => {
        const { user } = orgUser
        teamOptionsObj.push({
          value: `${user.id}`,
          label:
            user.firstName && user.lastName
              ? `${user.firstName} ${user.lastName}`
              : user.email,
        })
        teamMapObj = {
          ...teamMapObj,
          [`${user.id}`]: {
            firstName: user.firstName || user.email,
            lastName: user.lastName,
            email: user.email,
          },
        }
      })
      teamOptionsObj.sort((a: IOption, b: IOption) =>
        a.label > b.label ? 1 : -1
      )
      setTeamOptions(teamOptionsObj)
      setTeamMap(teamMapObj)
    }
  }, [teamData])

  return {
    teamOptions,
    teamMap,
  }
}

export default useNonprofitOrgTeam
